// 🔴🔴 N°702 — LA COMPRESSION PHOTO, UNE SEULE FOIS, POUR TOUT LE MONDE.
//
// ⚠️ CE FICHIER ⛔ N'INVENTE RIEN. C'est la fonction qui vivait, PRIVÉE, dans
// `components/dal/MobileDALWizard.jsx:520` — celle que Jordan utilise depuis des mois sur ses
// 28 photos par visite. Elle est reprise À L'IDENTIQUE : mêmes bornes (1920 px sur le côté long),
// même échelle de qualité (0,82 → 0,70 → 0,55, puis 0,45 en dernier ressort), même cible
// (≤ 900 Ko), même laissez-passer (sous le seuil, le fichier part TEL QUEL), même repli silencieux.
// ⛔ Y COMPRIS LE PRÉFIXE DE LOG « [DAL] » : mon banc d'identité m'a attrapé en train de
// l'avoir changé en « [photo] ». C'est cosmétique, et c'est précisément pour ça que ⛔ ça ⛔ ne
// justifie PAS de casser l'identité octet à octet. Le préfixe reste tel quel.
// ⛔ Aucun paramètre ⛔ n'a été retouché au passage : un traitement qu'on déplace et qu'on « améliore »
// en même temps ⛔ n'est plus le traitement qu'on avait éprouvé.
//
// 🔑 POURQUOI ELLE SORT DE LÀ : l'écran de visite de Mario envoyait le cliché BRUT — 4 à 12 Mo sur
// un Android récent — d'où le « Mémoire insuffisante » vécu par JJ. Le traitement EXISTAIT à trois
// portes de là, et ⛔ personne ⛔ ne pouvait l'appeler : il ⛔ n'était pas exporté. ⇒ Le défaut
// ⛔ n'était pas « il manque une compression », c'était « la compression ⛔ n'était pas partageable ».
//
// ⚠️ DETTE NOMMÉE, ⛔ PAS TRAITÉE ICI : il reste TROIS autres `compressImage` dans l'arbre —
// `pages/scanner/ScannerPage.jsx:53` et `components/scanner/MobileScanner.jsx:74` (1200 px / 0,75,
// et qui prennent une dataURL, ⛔ pas un File) et `pages/management/IdentiteEntreprise.jsx:119`
// (logo, 2 Mo). Elles ⛔ n'ont PAS la même signature : les fondre demande une mesure à elles seules.
// ⛔ Je ⛔ ne les touche pas dans ce lot.

/**
 * Compresse une image en JPEG côté client pour éviter 413 Nginx sur photos iPhone (~2-2,5 Mo)
 * et la saturation mémoire des WebView Android (4-12 Mo par cliché).
 * Cible : ≤ `maxBytes`. Si déjà sous le seuil, retourne le File original.
 * Redimensionne sur canvas (max 1920 px côté long) puis JPEG qualité 0,82 → 0,70 → 0,55.
 * ⛔ Ne lève JAMAIS : en cas d'échec, l'original est renvoyé — une photo perdue serait pire.
 */
export async function compressImage(file, maxBytes = 900 * 1024) {
  try {
    if (!file || !file.type?.startsWith("image/")) return file;
    if (file.size <= maxBytes) return file;

    const bitmap = await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });

    const MAX_EDGE = 1920;
    let { width, height } = bitmap;
    const ratio = Math.min(1, MAX_EDGE / Math.max(width, height));
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);

    // Itère qualité si encore trop gros (0.82 → 0.70 → 0.55)
    for (const q of [0.82, 0.70, 0.55]) {
      const blob = await new Promise(r => canvas.toBlob(r, "image/jpeg", q));
      if (blob && blob.size <= maxBytes) {
        return new File([blob], file.name.replace(/\.(heic|heif|png|webp)$/i, ".jpg"), {
          type: "image/jpeg",
          lastModified: Date.now(),
        });
      }
    }
    // Fallback : renvoie quand même la dernière compression la plus agressive
    const finalBlob = await new Promise(r => canvas.toBlob(r, "image/jpeg", 0.45));
    if (finalBlob) {
      return new File([finalBlob], file.name.replace(/\.\w+$/i, ".jpg"), {
        type: "image/jpeg",
        lastModified: Date.now(),
      });
    }
    return file;
  } catch (e) {
    console.warn("[DAL] compressImage fallback:", e);
    return file;
  }
}

export default compressImage;
